import Admin from "../Admin";
import React from "react";
import CardAdminIssueCategoryGeneral from "../../../Component/Card/Admin/IssueCategory/CardAdminIssueCategoryGeneral";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUISaveButton from "@mui/icons-material/Save";
import MUILoadingButton from "@mui/lab/LoadingButton";
import Menu from "../../../Component/Menu";
import DialogConfirm from "../../../Component/Dialog/DialogConfirm";
import MUIMenuItem from '@mui/material/MenuItem';
import MUIListItemIcon from '@mui/material/ListItemIcon';
import IssueCategoryService from "../../../Seating/Security/IssueCategoryService/issueCategoryService";
import Validator from "../../../Utility/Validator";
import IssueCategory from "../../../Utility/Crud/IssueCategory";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";

export default class AdminIssueCategoryCreateEdit extends Admin {
    constructor(props) {
        super(props);

        this.state.issueCategory = null;
        this.state.isProcessing = false;
        this.state.isUpdate = !!props.match.params.id;
        this.state.confirmDialogOpen = false;
        this.state.validationIssues = {};
    }

    /**
     * Set the issueCategory in the state.
     */
    afterComponentDidMount() {
        const issueCategoryId = this.props.match.params.id ? +this.props.match.params.id : null;
        if (issueCategoryId !== null) {
            this.setState({
                issueCategory: this.context.issueCategoriesIndexed[issueCategoryId]
            });
        }
    }

    /**
     * Creates the issueCategory with the current properties in state.issueCategory.
     */
    async createIssueCategory() {
        this.setState({
            isProcessing: true,
        });

        return IssueCategoryService.createIssueCategory(this.state.issueCategory)
            .then(issueCategory => {
                this.context.updateIndexed("issueCategoriesIndexed", issueCategory);
                this.props.history.goBack();
                NotistackEnqueueSnackbar("Issue Category created successfully!", { variant: "success" });
            })
            .catch((err) => {
                // JZ. We need to test and make sure that Sentry still captures
                // errors when we catch them in the application.
                console.log(err);
                NotistackEnqueueSnackbar("Oh no! There was an error creating a new Issue Category.", { variant: "error" });
                this.setState({
                    isProcessing: false,
                });
            });
    }

    /**
     * Updates the issueCategory with the current properties in state.issueCategory.
     */
    async updateIssueCategory() {
        this.setState({
            isProcessing: true,
        });

        return IssueCategoryService.updateIssueCategory(this.state.issueCategory)
            .then(issueCategory => {
                this.context.updateIndexed("issueCategoriesIndexed", issueCategory);
                this.props.history.goBack();
                NotistackEnqueueSnackbar("Issue Category updated successfully!", { variant: "success" });
            })
            .catch(err => {
                console.log(err);
                NotistackEnqueueSnackbar("Oh no! There was an error updating the Issue Category.", { variant: "error" });
                this.setState({
                    isProcessing: false,
                });
            });
    }

    async deleteIssueCategory() {
        this.setState({
            isProcessing: true,
        });

        return IssueCategoryService.deleteIssueCategory(this.state.issueCategory.id)
            .then(() => {
                this.context.deleteIndexed("issueCategoriesIndexed", this.state.issueCategory.id);
                this.props.history.goBack();
                NotistackEnqueueSnackbar("Issue Category deleted successfully!", { variant: "success" });
            })
            .catch((err) => {
                console.log(err);
                NotistackEnqueueSnackbar("Oh no! There was an error deleting the Issue Category.", { variant: "error" });
                this.setState({
                    confirmDialogOpen: false,
                });
            });

    }

    /**
     * Render the content.
     */
    renderContent() {
        const handleChange = (issueCategory) => {
            this.setState({
                issueCategory: {
                    ...this.state.issueCategory,
                    ...issueCategory
                },
            });
        };

        return (
            <>
                <CardAdminIssueCategoryGeneral
                    issueCategory={this.state.issueCategory}
                    onChange={handleChange.bind(this)}
                    validationIssues={this.state.validationIssues}
                />
                <DialogConfirm
                    open={this.state.confirmDialogOpen}
                    onClose={() => this.setState({ confirmDialogOpen: false })}
                    onConfirm={() => this.deleteIssueCategory()}
                    text="Are you sure you want to delete this Issue Category? This cannot be undone."
                    header="Delete Issue Category"
                    loading={this.state.isProcessing}
                />
            </>
        );
    }

    /**
    * Renders the header.
    */
    renderHeader() {
        let title;
        let subtitle;
        const buttonText = this.state.isUpdate ? "Save" : "Create";

        if (!this.state.isUpdate) {
            title = "Create Issue Category";
            subtitle = null;
        } else {
            title = "Edit Issue Category";
            subtitle = (this.state.issueCategory && (IssueCategory.getDisplayName(this.state.issueCategory) + " • " + this.state.issueCategory.id));
        }

        const handleClickBack = () => {
            this.props.history.goBack();
        };

        const handleClickSave = () => {
            const validationIssues = Validator.validate(
                this.state.issueCategory,
                {
                    name: {
                        'required': true
                    },
                }
            );

            this.setState({
                validationIssues: validationIssues,
            });


            if (Object.keys(validationIssues).length > 0) {
                return NotistackEnqueueSnackbar("Please correct the displayed issues.", { variant: "error" });
            }

            if (Object.keys(validationIssues).length === 0) {
                if (this.state.isUpdate) {
                    this.updateIssueCategory();
                } else {
                    this.createIssueCategory();
                }
            }

        };

        const handleDelete = () => {
            this.setState({
                confirmDialogOpen: true,
            });
        };

        const buttons = [
            (<MUIButton onClick={handleClickBack}>Back</MUIButton>),
            (
                <MUILoadingButton
                    loading={this.state.isProcessing}
                    loadingPosition="start"
                    onClick={handleClickSave}
                    variant="contained"
                    startIcon={<MUISaveButton />}>
                    {buttonText}
                </MUILoadingButton>
            )
        ];

        if (this.state.isUpdate) {
            const menuItems = [
                (
                    <MUIMenuItem onClick={handleDelete}>
                        <MUIListItemIcon>
                            <MUIDeleteIcon fontSize="small" />
                        </MUIListItemIcon>
                        Delete
                    </MUIMenuItem>
                )
            ];
            buttons.push((<Menu menuItems={menuItems} />));
        }

        return (
            <PageHeader title={title} subtitle={subtitle} buttons={buttons} />
        );
    }
}
